import $ from "jquery";

class CalcChumbadoresQuimicos {
    
    constructor() {
        
        /* global jQuery,calculoQuimicos */
        /* eslint no-alert: "off" */

        // Closure
        ( function( window, document, undefined ) {
            /**
             * Ajuste decimal de um número.
             *
             * @param	{string}	type	O tipo de arredondamento.
             * @param	{number}	value	O número a arredondar.
             * @param	{number}	exp		O expoente (o logaritmo decimal da base pretendida).
             * @return	{number}			O valor depois de ajustado.
             */
            function decimalAdjust( type, value, exp ) {
                // Se exp é indefinido ou zero...
                if ( typeof exp === 'undefined' || +exp === 0 ) {
                    return Math[ type ]( value );
                }
                value = +value;
                exp = +exp;
                // Se o valor não é um número ou o exp não é inteiro...
                if ( isNaN( value ) || ! ( typeof exp === 'number' && exp % 1 === 0 ) ) {
                    return NaN;
                }
                // Transformando para string
                value = value.toString().split( 'e' );
                value = Math[ type ]( +( value[ 0 ] + 'e' + ( value[ 1 ] ? ( +value[ 1 ] - exp ) : -exp ) ) );
                // Transformando de volta
                value = value.toString().split( 'e' );
                return +( value[ 0 ] + 'e' + ( value[ 1 ] ? ( +value[ 1 ] + exp ) : exp ) );
            }

            // Arredondamento decimal
            if ( ! Math.round10 ) {
                Math.round10 = function( value, exp ) {
                    return decimalAdjust( 'round', value, exp );
                };
            }
            // Decimal arredondado para baixo
            if ( ! Math.floor10 ) {
                Math.floor10 = function( value, exp ) {
                    return decimalAdjust( 'floor', value, exp );
                };
            }
            // Decimal arredondado para cima
            if ( ! Math.ceil10 ) {
                Math.ceil10 = function( value, exp ) {
                    return decimalAdjust( 'ceil', value, exp );
                };
            }

            let produto = $( '.produto-select.active' ).next().next().html();
            let ml = 300;
            let tipo = 'Barra Roscada';
            let diametroFuro;
            let diametroBarra;
            let profundidadeDoFuro;
            let desperdicio;
            let volumeResinaFuro;
            let escova;
            let escovaFoto;
            let brocaIndicada;
            let brocaIndicadaFoto;
            let fotoProduto;
            let quantidadeCartuchos;

            ml = $(".produto-select.active").parent().find("input[type=radio]").val();

            $( '.box-select' ).on( 'click', function() {
                $( '.produto-select' ).removeClass( 'active' );
                $( '.produto-select', this ).addClass( 'active' );

                $( '.box-select input[type=radio]' ).removeAttr( 'checked' );
                $( 'input[type=radio]', this ).attr( 'checked', 'checked' );
                ml = $( 'input[type=radio]', this ).val();
            } );

            $( '#calcular' ).on( 'click', function(e) {
                e.preventDefault();
                validaForm();
            } );

            function validaForm() {
                if ( '' === $( '#furos' ).val() ) {
                    alert( 'Preencha a quantidade de furos' );
                    $( '#furos' ).focus().css( 'border-color', 'red' );
                    return false;
                }

                if ( '' === $( '#diametro_furo' ).val() ) {
                    alert( 'Selecione o diâmetro da barra ou do vergalhão' );
                    $( '#select_barra_roscada' ).css( 'border-color', 'red' );
                    $( '#select_vergalhoes' ).css( 'border-color', 'red' );
                    return false;
                }

                if ( 'Selecione a profundidade' === $( '#produndidade_do_furo' ).val() ) {
                    alert( 'Preencha a profundidade do furo' );
                    $( '#produndidade_do_furo' ).focus().css( 'border-color', 'red' );
                    return false;
                }

                if ( '' === $( '#desperdicio' ).val() ) {
                    alert( 'Preencha o fator de desperdício' );
                    $( '#desperdicio' ).focus().css( 'border-color', 'red' );
                    return false;
                }

                if ( '' === $( '#email-final' ).val() ) {
                    alert( 'Preencha o campo de e-mail' );
                    $( '#email-final' ).focus().css( 'border-color', 'red' );
                    return false;
                }

                if ( '' === $( '#email-final' ).val() ) {
                    alert( 'Preencha o campo de e-mail' );
                    $( '#email-final' ).focus().css( 'border-color', 'red' );
                    return false;
                }

                if (!$( '#email-final' ).val().includes('@')) {
                    alert( 'Preencha o campo de e-mail com email válido' );
                    $( '#email-final' ).focus().css( 'border-color', 'red' );
                    return false;
                }

                $( '#furos' ).css( 'border-color', '#d9d9d9' );
                $( '#select_barra_roscada' ).css( 'border-color', '#d9d9d9' );
                $( '#produndidade_do_furo' ).css( 'border-color', '#d9d9d9' );
                $( '#desperdicio' ).css( 'border-color', '#d9d9d9' );
                $( '#email-final' ).css( 'border-color', '#d9d9d9' );

                calculoFinal();
            }

            $( '#select_barra_roscada' ).on( 'change', function() {
                $( '#diametro_furo' ).val( $( this ).val() );
                escova = $( 'option:checked', this ).data( 'escova' );
                escovaFoto = $( 'option:checked', this ).data( 'escovafoto' );
            } );

            $( '#select_vergalhoes' ).on( 'change', function() {
                $( '#diametro_furo' ).val( $( this ).val() );
                escova = $( 'option:checked', this ).data( 'escova' );
                escovaFoto = $( 'option:checked', this ).data( 'escovafoto' );
            } );

            $( '#barra_roscada' ).on( 'click', function() {
                $( '#select_barra_roscada' ).css( 'display', 'block' );
                $( '#select_vergalhoes' ).css( 'display', 'none' );
                tipo = $( 'input[name="tipo"]:checked' ).val();
                $( '#select_barra_roscada' ).val( $( '#select_barra_roscada option:first' ).val() );
                $( '#diametro_furo' ).val( '' );
                $( '#select_barra_roscada' ).parents( '.select-holder' ).parents( 'div' ).find( '> label' ).text( 'Diâmetro da Barra (pol):' );
            } );

            $( '#vergalhoes' ).on( 'click', function() {
                $( '#select_barra_roscada' ).css( 'display', 'none' );
                $( '#select_vergalhoes' ).css( 'display', 'block' );
                tipo = $( 'input[name="tipo"]:checked' ).val();
                $( '#select_vergalhoes' ).val( $( '#select_vergalhoes option:first' ).val() );
                $( '#diametro_furo' ).val( '' );
                $( '#select_vergalhoes' ).parents( '.select-holder' ).parents( 'div' ).find( '> label' ).text( 'Diâmetro do Vergalhão (mm):' );
            } );

            function calculoFinal() {
                $( '.applicator-result .remove-before-calc' ).remove();
                $( '.applicator-result' ).append( $( '.produto-select.active + .result-to-applicator tr' ).html() );
                
                setTimeout(() => {
                    location.href = "#result";
                }, 500);

                $( '.produto-select.active' ).next().next().html();

                produto = $( '.produto-select.active' ).next().next().html();

                if ( 'Barra Roscada' === tipo ) {
                    diametroFuro = parseInt( $( '#select_barra_roscada' ).val() );
                    diametroBarra = $( '#select_barra_roscada option:selected' ).text().replace( 'Barra Roscada ', '' ).replace( '"', '' );
                }

                if ( 'Vergalhões' === tipo ) {
                    diametroFuro = parseInt( $( '#select_vergalhoes' ).val() );
                    diametroBarra = parseFloat( $( '#select_vergalhoes option:selected' ).text().replace( 'Vergalhão ', '' ).replace( ' mm', '' ).replace( ',', '.' ) );
                }

                profundidadeDoFuro = parseInt( $( '#produndidade_do_furo' ).val() );
                desperdicio = $( '#desperdicio' ).val();

                volumeResinaFuro = ( 0.75 ) * ( 3.14 ) * ( diametroFuro * diametroFuro ) * profundidadeDoFuro * ( 1 + ( desperdicio / 100 ) ) / 4000;

                const volumeTotalResina = volumeResinaFuro * $( '#furos' ).val();

                quantidadeCartuchos = volumeTotalResina / ml;

                console.log(volumeTotalResina , ml);
                console.log(volumeTotalResina / ml);

                $( '.quantidade_cartuchos' ).html( Math.ceil10( quantidadeCartuchos ) );
                $( '.volume_total_resina' ).html( Math.ceil10( volumeTotalResina ) );
                $( '.volume_resina_furo' ).html( Math.ceil10( volumeResinaFuro, -2 ) );

                $( '.escova' ).html( escova );

                $( '.brocas li' ).css( 'display', 'none' );

                $( '.brocas li' ).each( function() {
                    if ( $( this ).data( 'diametro' ) === diametroFuro && $( this ).data( 'profundidade' ) === profundidadeDoFuro ) {
                        $( this ).fadeIn();
                        $( 'span', this ).html( $( this ).data( 'nome' ) );
                        brocaIndicada = $( this ).data( 'nome' );
                        brocaIndicadaFoto = $( 'img', this ).attr( 'src' );
                    }
                } );

                $( '.print_foto_produto' ).attr( 'src', $( '.produto-select.active img' ).attr( 'src' ) );
                $( '.print_broca_foto' ).attr( 'src', brocaIndicadaFoto );
                $( '.quantidade_furos' ).text( $( '#furos' ).val() );
                $( '.diametro_furo' ).text( diametroFuro );
                $( '.profundidade_furo' ).text( profundidadeDoFuro );
                $( '.fator_desperdicio' ).text( desperdicio );
                $( '.print_broca' ).text( brocaIndicada );

                $( '.result' ).css( 'display', 'block' );

                fotoProduto = $( '.produto-select.active img' ).attr( 'src' );

                let dataCalc = new FormData();

                dataCalc.append('action', 'send_mail_calc_chumbadores');
                dataCalc.append('email', $( '#email-final' ).val());
                dataCalc.append('tipo', tipo);
                dataCalc.append('quantidade_furos', $( '#furos' ).val());
                dataCalc.append('diametro_furo', diametroFuro);
                dataCalc.append('diametro_barra', diametroBarra);
                dataCalc.append('profundidade_furos', profundidadeDoFuro);
                dataCalc.append('fator_desperdicio', desperdicio);
                dataCalc.append('quantidade_estimada_cartuchos', Math.ceil10( quantidadeCartuchos ));
                dataCalc.append('volume_total', Math.ceil10( volumeTotalResina ));
                dataCalc.append('volume_furo', Math.ceil10( volumeResinaFuro, -2 ) );
                dataCalc.append('broca_indicada', brocaIndicada);
                dataCalc.append('broca_indicada_foto', brocaIndicadaFoto);
                dataCalc.append('foto_produto', fotoProduto);
                dataCalc.append('escova_recomendada_foto', escovaFoto);
                dataCalc.append('escova_recomendada', escova);
                dataCalc.append('soprador', $( '.soprador > span' ).text());
                dataCalc.append('soprador_foto', $( '.soprador > img' ).attr( 'src' ));
                dataCalc.append('aplicador', $( '.produto-select.active + .result-to-applicator tr td > span:first' ).text());
                dataCalc.append('aplicador_foto', $( '.produto-select.active + .result-to-applicator tr td > img' ).attr( 'src' ));

                fetch(ajaxurl, {
                    method: 'POST',
                    body: dataCalc
                })
                    .then(response => {
                        response.json()
                            .then(data => {
                                console.log(data);
                            });
                    });

                return false;
            }

            function solicitarOrcamento() {
                $( '.box-solicitar-orcamento' ).fadeIn();
                $( '.bg' ).fadeIn();
                $( '.orcamento-produto' ).val( produto );
                $( '.orcamento-quantidade' ).val( Math.ceil10( quantidadeCartuchos ) );
                $( '.orcamento-escova' ).val( 'Escova ' + escova );
                $( '.orcamento-quantidadeescova' ).val( Math.ceil10( quantidadeCartuchos ) );
                $( '.orcamento-broca' ).val( 'Broca ' + brocaIndicada );
                $( '.orcamento-quantidadebrocas' ).val( Math.ceil10( quantidadeCartuchos ) );
                $( '.orcamento-quantidadesoprador' ).val( Math.ceil10( quantidadeCartuchos ) );
                $( '.orcamento-aplicador' ).html( $( '.produto-select.active + .result-to-applicator + p + input + .result-to-form-orcamento' ).html() );
                $( '.orcamento-quantidadeaplicador' ).val( Math.ceil10( quantidadeCartuchos ) );

                return false;
            }
            $( '#solicitarOrcamento' ).on('click', solicitarOrcamento );

            function solicitarInformacoes() {
                document.querySelector('.modal-informacoes').classList.add('show');
                $(".box-solicitar-informacoes").fadeIn();
                console.log($(".box-solicitar-informacoes"));
                $(".bg").fadeIn();
                $(".message").attr('placeholder','Quero informações sobre Rejunte Infinity');
                return false;
            }
            
            $("#solicitarInformacore").on('click', solicitarInformacoes);



            function imprimir() {
                $( '.master-wrap .infos-top' ).hide();

                $( '.master-wrap header' ).hide();
                $( '.master-wrap .sidenav' ).hide();
                $( '.master-wrap .topo.topo-small' ).hide();
                $( '.master-wrap .bg-white' ).hide();
                $( '.master-wrap footer' ).hide();

                $( '.mostra-print' ).show();

                setTimeout( function() {
                    window.print();
                    $( '.master-wrap .infos-top' ).show();
                    $( '.master-wrap header' ).show();
                    $( '.master-wrap .sidenav' ).show();
                    $( '.master-wrap .topo.topo-small' ).show();
                    $( '.master-wrap .bg-white' ).show();
                    $( '.master-wrap footer' ).show();
                    $( '.mostra-print' ).hide();
                }, 1000 );
            }
            $( '#imprimir' ).on('click', imprimir );

            $( '.form-orcamento-calculo' ).on( 'submit', function() {
                $( '#retorno-orcamento-calculo' ).html( 'Enviando...' );

                let dataCalc = new FormData();

                dataCalc.append('action', 'send_mail_calc_chumbadores');
                dataCalc.append('email', $( '#email-final' ).val());
                dataCalc.append('tipo', tipo);
                dataCalc.append('quantidade_furos', $( '#furos' ).val());
                dataCalc.append('diametro_furo', diametroFuro);
                dataCalc.append('diametro_barra', diametroBarra);
                dataCalc.append('profundidade_furos', profundidadeDoFuro);
                dataCalc.append('fator_desperdicio', desperdicio);
                dataCalc.append('quantidade_estimada_cartuchos', Math.ceil10( quantidadeCartuchos ));
                dataCalc.append('volume_total', Math.ceil10( volumeTotalResina ));
                dataCalc.append('volume_furo', Math.ceil10( volumeResinaFuro), -2 );
                dataCalc.append('broca_indicada', brocaIndicada);
                dataCalc.append('broca_indicada_foto', brocaIndicadaFoto);
                dataCalc.append('foto_produto', fotoProduto);
                dataCalc.append('escova_recomendada_foto', escovaFoto);
                dataCalc.append('escova_recomendada', escova);
                dataCalc.append('soprador', $( '.soprador > span' ).text());
                dataCalc.append('soprador_foto', $( '.soprador > img' ).attr( 'src' ));
                dataCalc.append('aplicador', $( '.produto-select.active + .result-to-applicator tr td > span:first' ).text());
                dataCalc.append('aplicador_foto', $( '.produto-select.active + .result-to-applicator tr td > img' ).attr( 'src' ));

                fetch(ajaxurl, {
                    method: 'POST',
                    body: dataCalc
                })
                    .then(response => {
                        response.json()
                            .then(data => {
                                console.log(data);
                            });
                    });
                $.ajax( {
                    url: '?page-orcamento-calculo-envia',
                    method: 'POST',
                    data: $( this ).serialize(),
                } ).done( function( ret ) {
                    if ( ret.success ) {
                        $( '.form-orcamento-calculo' )[ 0 ].reset();
                        $( '#retorno-orcamento-calculo' ).html( 'Enviado com sucesso.' );
                        setTimeout( function() {
                            window.location.href = calculoQuimicos.home + '/obrigado/calculo-quimicos';
                        }, 1000 );
                    } else {
                        $( '#retorno-orcamento-calculo' ).html( 'Falha ao enviar.' );
                    }
                } );
                return false;
            } );
        }( window, document ) );

       

    }

}

export default CalcChumbadoresQuimicos;